import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import AccountList2 from '../../component/Account/AccountList2';
import musicTitle from '../../asset/music/winter.mp3';
import ParentInfo from '../../component/Info/ParentInfo';

const ParkSol = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "동규♥솔 결혼합니다!";
    const openDesc = "2025년 9월 20일 토요일, 오후 5시";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/260/thumb.jpg";

    const lng = 127.026914460572;
    const lat = 37.4966333557707;

    const placeTelNum = "";


    const forCar = "· 서울 서초구 서초동 1320-10 삼성전자 서초사옥\n  지하주차장 이용 (3시간 무료)\n  지하주차장 연결 엘리베이터 탑승 5층";
    const forBus = "· 광역(R) 9200, 9300, 9404, 9408, 9409, 9100, 9500, \n  9711, 9800, M6405, M6462, M7412\n· 간선(B) 140, 340, 402, 420, 440, 470\n· 지선(G) 서초03, 서초09, 서초10, 서초11";
    const forSubway = `· 2호선/신분당선 강남역 8번 출구 지하연결통로 이용\n  지상 1층 외부 투명 엘리베이터 탑승 5층`;
    

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    // const conceptStyle = {
    //     // summer 연올리브
    //     concept: "SUMMER",
    //     titleColor: "#76902F",
    //     pointColor: "#76902F",
    //     btnBgColor: "#76902F",
    //     fontColor: "#ffffff",
    //     btnFontColor: "#ffffff",
    //     chatBgColor: "#F5F8FF",
    //     fontFamilyKo: "SCDream3",
    //     fontFamilyEn: "Edensor"
    // }
    // #77a4e0
    // #7ea2d7
    const conceptStyle = {
        // summer
        concept: "SUMMER",
        titleColor: "#7ea2d7",
        pointColor: "#7ea2d7",
        btnBgColor: "#7ea2d7",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }

    const title = "우리의 사랑은 바다를 닮았습니다."

    const msg1 = "밀려오고, 안기고, 다시 다가오며\n서로의 품에 파도처럼 머물렀습니다.";
    const msg2 = "윤슬이 일렁이는 바다와 같이\n서로의 마음을 비추며 살아가고자 합니다.";
    const msg3 = "두 사람의 첫 시작, \n그 소중한 자리에 함께해 주세요.\n\n"

    const parents = [
        {groom : "❁김성순 · 송원희의 아들"},
        {bride : "박형록 · 조계숙의 딸"}
    ]


    const parentInfo = {
        groom: {
            dad: { name: "김성순", isDeceased: true },
            mom: { name: "송원희", isDeceased: false },
            role: "아들",
        },
        bride: {
            dad: { name: "박형록", isDeceased: false },
            mom: { name: "조계숙", isDeceased: false },
            role: "딸",
        }
    };

    const groomAccountList = [
        {
            role: "신랑",
            name: "김동규",
            bank: "신한은행",
            accountNumber : "110-314-243411",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Fc6al72Fc"
        }
        ,{
            role: "어머니",
            name: "송원희",
            bank: "우리은행",
            accountNumber : "1002-606-823404",
            isKakao : false
        }
        ,{
            role: "누나",
            name: "김현신",
            bank: "카카오뱅크",
            accountNumber : "3333-14-1515053",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "박 솔",
            bank: "국민은행",
            accountNumber : "202602-04-220037",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FafuHwJYH"
        }
        ,{
            role: "아버지",
            name: "박형록",
            bank: "신한은행",
            accountNumber : "110-147-539342",
            isKakao : false
        }
        ,{
            role: "어머니",
            name: "조계숙",
            bank: "신한은행",
            accountNumber : "110-146-358781",
            isKakao : false
        }
    ]

    const account_explain = "참석이 어려우신 분들을 위해 계좌번호를 기재합니다.\n축하의 마음을 전해주세요.";

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "금진해변 앞",
            brideAnswer: "알로하서프!"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "개보옹박두",
            brideAnswer: "두구두구두"
        },
        {
            question : "우리의 결혼은 어떤 모습일까?",
            groomAnswer: "장르는 로코",
            brideAnswer: "달콤 쌉싸름"
        },
        {
            question : "서로에게 하고 싶은 말!",
            groomAnswer: "그대는 행복",
            brideAnswer: "그 자체였다"
        }
        ,{
            question : "마지막으로 전하고 싶은 이야기!",
            groomAnswer: "알콩♡달콩",
            brideAnswer: "잘 살게요♥"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "이상현",
            call: "010-5048-1259"
        }
        ,{
            role: "신랑 부",
            name: "이용우",
            call: "010-4103-1248"
        }
        ,{
            role: "신랑 모",
            name: "이영실",
            call: "010-7137-1248"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "조아인",
            call: "010-6389-6551"
        }
        ,{
            role: "신부 부",
            name: "조양주",
            call: "010-3789-6551"
        }
        ,{
            role: "신부 모",
            name: "박은영",
            call: "010-9040-6551"
        }
    ]

    const informationList =[
        {
            title : "식사 안내",
            content : "아래 식당에 식사 자리를 마련했습니다.\n원하시는 곳에서 식사가 가능합니다. \n\n· [양식] 매드포갈릭 (본 건물 지하 1층)\n· [일식] 아카사카 (외부 건물 도보 5분)\n\n 이용시간 16:00~19:00\n\n소중한 마음으로 인사 드리겠습니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
        // #76902F
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#7ea2d7"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getFirstEnName(weddingData.brideNameEn)} brideNameEn={getFirstEnName(weddingData.groomNameEn)} color={"#ffffff"} letteringFontColor={"#ffffff"} dateColor={"#ffffff"} bottom={"75%"} bottom2={"65.5%"} dateBottom={"1%"} top={"5%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2 isDetailTimeToKo={true} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    {/* <CallInfo marginTop={"10px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> 
                    <Dday_Spring brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList desc={"갤러리"} fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"4px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forCar={forCar} forBus={forBus} forSubway={forSubway} conceptStyle={conceptStyle}/>
                    {/* <Information divMarginBottom={"70px"} width={"310px"} divHeight={"300px"} pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default ParkSol;